import { render, staticRenderFns } from "./PublicTracker.vue?vue&type=template&id=3b0889a0&scoped=true&"
import script from "./PublicTracker.vue?vue&type=script&setup=true&lang=js&"
export * from "./PublicTracker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0889a0",
  null
  
)

export default component.exports